export default __webpack_public_path__ + "static/floor1_image2-pc-57316619bbef00db40f13712aacfaf82.png";